import React from 'react';
import ListItem from './ListItem';

const LogsList = ({ data, is_fetched }) => {

    if (!is_fetched) {
        return null;
    }

    if (!data.length) {
        return (
            <div style={{textAlign: 'center', marginTop: '20px'}}>
                <p>Nenhum registro encontrado.</p>
            </div>
        );
    }

    const logs = data.map(log => {
        return (<ListItem key={log.id} data={log} />)
    })

    return (
        <table className="table logs-table">
            <thead>
                <tr>
                    <th>Data</th>
                    <th>Mensagem</th>
                    <th>Tipo</th>
                    <th>Operação</th>
                    <th>Contextos</th>
                    <th>Usuário</th>
                </tr>
            </thead>

            {logs}
        </table>
    );
}

LogsList.defaultProps = {
    data: []
}

export default LogsList;



// WEBPACK FOOTER //
// ./src/components/Logs/List.js